import { createFileRoute } from "@tanstack/react-router"
import { lazy } from "react"
import LazyRoutePage from "../../../../-LazyRoutePage"

const SalesOfferPage = lazy(
  () => import("../../../../../components/WMS/SalesOffers/SalesOfferPage.tsx"),
)

export const Route = createFileRoute(
  "/_layout/WMS/documents/sales-offers/$salesOffer",
)({
  component: SalesOfferRoute,
  validateSearch: (search: { tab?: unknown; edit?: unknown }) => ({
    tab:
      search.tab === "info" ||
      search.tab === "files" ||
      search.tab === "general"
        ? search.tab
        : undefined,
    edit:
      search.edit === 1 || search.edit === "1" || search.edit === true
        ? 1
        : undefined,
  }),
})

function SalesOfferRoute() {
  return (
    <LazyRoutePage>
      <SalesOfferPage />
    </LazyRoutePage>
  )
}
